module.exports = __webpack_public_path__ + "static/media/5.c9708a21.jpeg";